// src/pages/menu-items/AfricanMenuItems.jsx
import React from 'react';
import MenuItemList from '../MenuItemList';

const AfricanMenuItems = () => {
  return <MenuItemList locationKey="african" />;
};

export default AfricanMenuItems;